export default {
    UPDATE_USER_INFO:'UPDATE_USER_INFO',
    ALL_TASKS: 'All_TASKS',
    PENDING_TASKS: 'PENDING_TASKS',
    GET_USER_INFO: 'GET_USER_INFO'
};
